// 根据电脑来判断语言
module.exports = {
	toast: {
		agreementTips: '请先阅读并同意协议',
		noPhone: '手机号不能为空',
		noEmail: '邮箱不能为空',
		verifyphoneTips: '请输入正确手机号',
		verifyemailTips: '请输入正确邮箱',
		verifycodeTips: '验证码不能为空',
		noAccount: '账号不能为空',
		verifypAccount: '账号格式不正确',
		nopsw: '密码不能为空',
		verifypswTips: '密码需为6-18位非中文/空格字符',
		newverifypswTips: '请输入6-18位非中文/空格字符的新密码',

		noName: '姓名不能为空',
		noID: '身份证号不能为空',
		verifyIDTips: '请输入有效身份证号',
		comfirmPswTips: '请保持两次输入密码一致',

		accountPlaceholder: '请输入手机号/番糖通行证账号/邮箱',
		phonePlaceholder: '请输入手机号码',
		pswPlaceholder: '请输入密码',
		newPswPlaceHolder: '请输入新密码',
		confirmPswPlaceholder: '请确认密码',
		IDPlaceholder: '请输入身份证号',
		namePlaceholder: '请输入真实姓名',
		verifycodePlaceholder: '请输入验证码',
		findAccountPlaceHolder: '请输入您要找回的账号',

		findAccountTxt1: '请输入需要重置密码的账号',
		findAccountTxt2: '点击获取验证码,短信将发送至您的绑定手机',
		verifycodeBtn: '获取',
		verifycodeBtn2: '重新获取',
		gotoRegister: '立即注册',
		gotoGame: '进入游戏',
		findAccount: '忘记密码？戳我解决',
		gotoAccountLogin: '账号密码登录',
		agreementText: '我已阅读并同意',
		userAgreementName: '用户协议',
		privacyAgreementName: '隐私协议',
		agreementText2: '注册即代表您同意并遵守',
		loginErrorTips: '登录状态异常需要完成安全验证',
		phoneVerify: '验证绑定手机',
		and: '和',
		comfirmBtn1: '提交',
		comfirmBtn2: '确认',
		comfirmBtn3: '注册',
		comfirmBtn4: '返回',
		comfirmBtn5: '取消',
		comunicaton1: '手机',
		comunicaton2: '手机号',
		changepswTxt1: '设置账号',
		changepswTxt2: '的新密码',

		bannerGameTxt1: '提示',
		bannerGameTxt2:
			'您认证的身份信息为未成年人，请在监护人的监督下进行游戏。',
		bannerGameTxt3: '为了您的身心健康，请合理安排游戏时间',

		agreementTips1:
			'用户协议内容有更新，请认真阅读。点击同意后才可以使用本产品',
		agreementTips2: '阅读并同意全部协议后可继续游戏',
		agreementTips3: '拒绝',
		agreementTips4: '同意',
		agreementTips5: '阅读完全部内容，可点击同意按钮',
		agreementTips6: '请阅读并同意协议，再进入游戏',

		bindIdTxt1: '根据国家要求规定，游戏用户必须进行实名认证，',
		bindIdTxt2: '我们承诺将严格保密您的信息安全。',

		bindPhoneTxt1: '进入游戏前请先绑定手机：',

		loginErrorTxt1: '登录状态异常需要完成安全验证',
		loginErrorTxt2: '验证绑定手机：',

		scuessTitle: '欢迎进入游戏',
	},
};
